import { useSizes } from '@hg/stylizator/hooks'
import { Logo, LogoXmas } from '@hg/stylizator/icons'
import { Optional } from '@hg/stylizator/utils'
import * as React from 'react'

import Header from 'app/components/Header'
import { IResponseMenuItem } from 'app/service/api/theme'
import { useGlobalState } from 'app/store'

interface IProps {
  isXmas?: boolean
  logoUrl?: string
  menuItems: IResponseMenuItem[]
}

const TopMenu: React.FC<IProps> = (props) => {
  const [opened, setOpened] = React.useState<Optional<boolean>>()
  const [languages] = useGlobalState('languages')
  const [scrolled, setScrolled] = React.useState(false)
  const { isDesktop } = useSizes()

  if (isDesktop) {
    if (opened) {
      setOpened(false)
    }
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
  }

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const handleScroll = (): void => {
      setScrolled(window.scrollY > 64)
    }

    window.addEventListener('scroll', handleScroll)

    return (): void => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Header
      logoUrl={props.logoUrl}
      languages={languages}
      scrolled={scrolled}
      opened={opened}
      onMenuToggle={() => {
        setOpened((val) => !val)
        document.body.style.overflow = !opened ? 'hidden' : ''
      }}
      items={props.menuItems}
      logo={props.isXmas ? <LogoXmas /> : <Logo />}
    />
  )
}

export default TopMenu
